import { useCallback } from 'react';
import { useDispatch } from 'react-redux';

import { Params } from './types';
import useMakePushData, { PushState } from './useMakePushData';

export type Push = (to: string, state?: PushState, params?: Params) => void;

export default (): Push => {
    const makePushData = useMakePushData('usePush');
    const dispatch = useDispatch();

    return useCallback(
        (to: string, state?: PushState, params?: Params) => {
            const { url, pushAction, useRoutingBySPA } = makePushData(to, state, params);
            if (useRoutingBySPA) {
                dispatch(pushAction);
            } else {
                window.location.assign(url);
            }
        },
        [dispatch, makePushData]
    );
};
